import {
  Box,
  Grid,
  TextField,
  Typography,
  Paper,
  IconButton,
  Button,
  Avatar,
  InputAdornment,
  ButtonGroup,
  Checkbox,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
// import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid } from "@mui/x-data-grid";
import { useState, useEffect, useCallback } from "react";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import BlockIcon from "@mui/icons-material/Block";
import AppBreadcrumbs from "./../../components/AppBreadcrumbs";
import toast, { Toaster } from "react-hot-toast";
import { jwtDecode } from "jwt-decode";
import { useParams, useLocation } from "react-router-dom";
import * as services from "../../services/saleng";
import NoPhotographyOutlinedIcon from "@mui/icons-material/NoPhotographyOutlined";
import { formatNumber } from "./../../utils/formatNumber";
import AddIcon from "@mui/icons-material/Add";
import moment from "moment";
import "moment/locale/th";

const GroupPricingPage = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [shopId, setShopId] = useState(null);
  const [rowModesModel, setRowModesModel] = useState({});
  const [customers, setCustomers] = useState([]);

  const [userSearch, setUserSearch] = useState("");
  const [productSearch, setProductSearch] = useState("");

  const [search, setSearch] = useState("");
  const [type, setType] = useState("open");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [selectedUserId, setSelectedUserId] = useState(null);
  const [products, setProducts] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingProducts, setLoadingProducts] = useState(false);

  const getMinEndDate = (start) =>
    new Date(new Date(start).setDate(new Date(start).getDate() + 1))
      .toISOString()
      .split("T")[0];

  // const filteredUsers = customers.filter((u) =>
  //   u.name.toLowerCase().includes(userSearch.toLowerCase())
  // );

  // const filteredProducts = products.filter(
  //   (p) =>
  //     // p.title.toLowerCase().includes(productSearch.toLowerCase()) ||
  //     p.category.includes(productSearch) ||
  //     p.subCategory.includes(productSearch)
  // );

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);
        if (decoded.id) {
          setShopId(decoded.id);
        }
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);

  // โหลด Users
  useEffect(() => {
    const fetchUsers = async () => {
      setLoadingUsers(true);
      try {
        const res = await services.getCustomers();
        console.log("res", res);
        setCustomers(res.data.data || []);
      } catch (err) {
        toast.error("โหลดรายชื่อผู้ใช้ไม่สำเร็จ");
      } finally {
        setLoadingUsers(false);
      }
    };
    fetchUsers();
  }, []);

  // โหลดสินค้าเมื่อเลือก user
  useEffect(() => {
    const fetchProducts = async () => {
      if (!selectedUserId) return;

      setLoadingProducts(true);
      try {
        // ใช้ selectedUserId เป็น customerId
        const customerId = selectedUserId;

        const res = await services.getLockPricingByCustomer(customerId);
        const result = res.data

        const mappedData = result.data.map((item) => ({
          id: item.id,
          transactionItemId: item.transactionItemId,
          productId: item.productId,
          status: item.status,
          lockWeight: item.lockWeight,
          actualWeight: item.actualWeight,
          purchasePrice: item.purchasePrice,
          predictPrice: item.predictPrice,
          deletedAt: item.deletedAt,
          createdAt: item.createdAt,
          updatedAt: item.updatedAt,
          category: item.product?.category?.name || "",
          product: item.product?.title || "",
          unit: "กก.",
          // หรือข้อมูลอื่นๆที่จำเป็น
        }));

        // สมมติมี setProducts เพื่อเก็บข้อมูล
        setProducts(mappedData || []);
      } catch (error) {
        console.error("Error fetching lock-pricing:", error);
        // ถ้ามี toast
        // toast.error("โหลดข้อมูลไม่สำเร็จ");
      } finally {
        setLoadingProducts(false);
      }
    };

    fetchProducts();
  }, [selectedUserId]);

  // const fetchData = useCallback(async () => {
  //   // const res = await services.getProducts(shopId);
  //   // const products = res.data.data;

  //   // const adjRes = await services.getProductGroupsAdjustments(id);
  //   // const adjustments = adjRes.data.data;

  //   const userRes = await services.getCustomers();
  //   const users = userRes.data.data;

  //   console.log("users", users);

  //   // const productsWithIndex = products.map((item, index) => {
  //   //   const adjItem = adjustments.find((a) => a.productId === item.id);
  //   //   const adjustment = adjItem?.adjustment ?? 0;
  //   //   return {
  //   //     ...item,
  //   //     no: index + 1,
  //   //     category: item.category.name,
  //   //     subCategory: item.subCategory.name,
  //   //     adjustment,
  //   //     total: (item.price ?? 0) + adjustment,
  //   //     adjItem: !!adjItem,
  //   //   };
  //   // });

  //   // setProducts(productsWithIndex);
  //   setCustomers(users);
  //   setLoading(false);
  // }, []);

  // useEffect(() => {
  //   if (shopId) fetchData();
  // }, [fetchData, shopId]);

  const processRowUpdate = async (newRow) => {
    newRow.total = Number(newRow.price) + Number(newRow.adjustment);

    const payload = {
      shopId,
      productId: newRow.id,
      adjustment: newRow.adjustment,
    };

    try {
      //   if (newRow.adjItem) {
      //     // มี adjustment อยู่แล้ว → ทำการ update
      //     await services.updateProductGroupsAdjustments(payload, id);
      //     console.log("🔄 update");
      //   } else {
      //     // ยังไม่มี adjustment → สร้างใหม่
      //     await services.createProductGroupsAdjustments(payload, id);
      //     console.log("✨ create");
      //     payload.adjItem = true;
      //   }

      setProducts((prev) =>
        prev.map((p) => (p.id === newRow.id ? { ...p, ...newRow } : p))
      );
      toast.success("อัปเดตราคาสำเร็จแล้ว");
      return { ...newRow, isNew: false };
    } catch (error) {
      console.error("Error updating row:", error);
      toast.error("เกิดข้อผิดพลาดในการอัปเดตราคา");
      throw error;
    }
  };

  const columns = [
    {
      field: "category",
      headerName: "ประเภท",
      flex: 0,
      minWidth: 150,
    },
    {
      field: "product",
      headerName: "สินค้า",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "unit",
      headerName: "หน่วย",
      flex: 0,
      minWidth: 150,
    },
    {
      field: "poWeight",
      headerName: "น้ำหนักขายจริง / น้ำหนักล็อค",
      type: "number",
      flex: 1,
      minWidth: 150,
      sortable: false,
      editable: true,
      renderCell: (params) => {
        const { actualWeight = 0, lockWeight = 0, isSummary } = params.row;

        if (isSummary) {
          return (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                pr: 1,
              }}
            >
              <Box display="flex" alignItems="center" gap={0.5}>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {formatNumber(actualWeight)}
                </Typography>
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ fontWeight: "bold" }}
                >
                  /
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                  {formatNumber(lockWeight)}
                </Typography>
              </Box>
            </Box>
          );
        }

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              pr: 1,
            }}
          >
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="body2">
                {formatNumber(actualWeight)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                /
              </Typography>

              <Typography variant="body2" color="primary">
                {formatNumber(lockWeight)}
              </Typography>
              <EditIcon sx={{ color: "primary.main", ml: 0.5 }} />
            </Box>
          </Box>
        );
      },
    },
    {
      field: "purchasePrice",
      headerName: "ราคาซื้อ",
      type: "number",
      flex: 0,
      minWidth: 150,
      sortable: false,
      editable: true,
      renderCell: (params) => {
        const { purchasePrice = 0, isSummary } = params.row;

        if (isSummary) {
          return null;
        }

        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              pr: 1,
            }}
          >
            <Box display="flex" alignItems="center" gap={0.5}>
              <Typography variant="body2" color="primary">
                {formatNumber(purchasePrice)}
              </Typography>
              <EditIcon sx={{ color: "primary.main", ml: 0.5 }} />
            </Box>
          </Box>
        );
      },
    },
    {
      field: "predictPrice",
      headerName: "ราคา (คาดการณ์)",
      type: "number",
      flex: 0,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "createdAt",
      headerName: "วันที่เปิด",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        const value = params.value;
        if (!value) return "-";

        const formattedDate = moment(value)
          .add(543, "year")
          .format("D MMM YYYY เวลา HH:mm");

        return <span>{formattedDate}</span>;
      },
    },
    {
      field: "status",
      headerName: "",
      flex: 0,
      minWidth: 100,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const status = params.value;

        if (status === "OPEN") {
          return <CheckIcon style={{ color: "green" }} />;
        } else if (status === "CLOSED") {
          return <CloseIcon style={{ color: "red" }} />;
        } else if (status === "CANCELLED") {
          return <BlockIcon style={{ color: "orange" }} />;
        } else {
          return null;
        }
      },
    },
  ];

  return (
    <Box p={2}>
      <AppBreadcrumbs />
      <Toaster position="bottom-left" reverseOrder={false} />
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          my: 2,
        }}
      >
        <Typography component="h2" variant="h5">
          การล็อกราคาสินค้า
        </Typography>
        {/* <Button color="success" variant="contained" onClick={() => { setEditData(null); setOpenDialog(true); }}>เพิ่มกลุ่มซัพพลายเออร์</Button> */}
      </Box>
      <Grid container spacing={2}>
        {/* LEFT COLUMN - Users */}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            placeholder="ค้นหาด้วยชื่อหรือทะเบียนรถ"
            value={userSearch}
            onChange={(e) => setUserSearch(e.target.value)}
            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
          />
          <Paper
            variant="outlined"
            sx={{ mt: 2, maxHeight: 600, overflow: "auto" }}
          >
            {/* {filteredUsers.map((user) => { */}
            {customers.map((user) => {
              const isSelected = selectedUserId === user.id;

              return (
                <Box
                  key={user.id}
                  onClick={() => setSelectedUserId(user.id)}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    px: 2,
                    py: 1,
                    borderBottom: "1px solid #eee",
                    cursor: "pointer",
                    backgroundColor: isSelected ? "grey.100" : "transparent",
                    border: isSelected ? "grey.100" : "transparent",
                    borderRadius: 1,
                    transition: "0.2s",
                  }}
                >
                  <Avatar src={user.img} sx={{ width: 50, height: 50, mr: 1 }}>
                    {!user.img && (
                      <NoPhotographyOutlinedIcon fontSize="large" />
                    )}
                  </Avatar>
                  <Box sx={{ flex: 1 }}>
                    <Typography>{user.name}</Typography>
                    <Typography variant="body2" color="textSecondary">
                      {user.personType === "corporate"
                        ? "นิติบุคคล"
                        : "บุคคลธรรมดา"}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Paper>
        </Grid>

        {/* RIGHT COLUMN - Products */}
        <Grid item xs={12} md={9}>
          {/* <TextField
            fullWidth
            placeholder="ค้นหาด้วยชื่อสินค้า หรือหมวดหมู่หลัก"
            value={productSearch}
            onChange={(e) => setProductSearch(e.target.value)}
            InputProps={{ startAdornment: <SearchIcon sx={{ mr: 1 }} /> }}
          /> */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <TextField
              fullWidth
              placeholder="ค้นหารายละเอียด"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              sx={{ maxWidth: 500 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={() => navigator("po_create")}
              size="large"
            >
              เพิ่มสินค้า
            </Button>
          </Box>

          {/* แถวที่สอง */}
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mt={2}
            flexWrap="wrap"
          >
            <ButtonGroup variant="outlined" color="success">
              <Button
                variant={type === "open" ? "contained" : "outlined"}
                onClick={() => setType("open")}
              >
                กำลังดำเนินการ
              </Button>
              <Button
                variant={type === "close" ? "contained" : "outlined"}
                onClick={() => setType("close")}
              >
                เสร็จสิ้นแล้ว
              </Button>
              <Button
                variant={type === "cancel" ? "contained" : "outlined"}
                onClick={() => setType("cancel")}
              >
                ยกเลิก
              </Button>
            </ButtonGroup>

            <Box display="flex" gap={2}>
              <TextField
                label="เริ่มต้น"
                type="date"
                value={startDate || ""}
                onChange={(e) => {
                  setStartDate(e.target.value);
                  setEndDate(null);
                }}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="สิ้นสุด"
                type="date"
                value={endDate || ""}
                onChange={(e) => setEndDate(e.target.value)}
                InputLabelProps={{ shrink: true }}
                inputProps={{
                  min: startDate ? getMinEndDate(startDate) : undefined,
                }}
              />
            </Box>
          </Box>
          <Box sx={{ mt: 2 }}>
            <DataGrid
              // rows={filteredProducts}
              rows={products}
              columns={columns}
              // processRowUpdate={processRowUpdate}
              // pageSize={10}
              // rowsPerPageOptions={[10, 25, 50]}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GroupPricingPage;
